import React, { useState } from "react";
import styled from "@emotion/styled";
import BackHeader from "@components/header/BackHeader";
import TabWithPanel from "@components/tab/TabWithPanel";
import { ReviewList } from "@pages/myPage/_component";
import SellerInfoCard from "@components/card/SellerInfoCard";
import { useNavigate, useParams } from "react-router-dom";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import useUserInfoStore from "@store/useUserInfoStore";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
});

const InfoWrapper = styled.div({
  padding: "2rem",
});

const Review = () => {
  const params = useParams();
  const sellerId = Number(params.sellerId);
  const { t } = useTranslation();
  const { getReceivedReviewList, getMyReviewList } = useApiRequest();
  const { userInfo } = useUserInfoStore();
  const mine = userInfo?.id === sellerId;
  const navigate = useNavigate();

  const { data: receivedReviewList } = useQuery({
    queryKey: ["receivedReviewList", sellerId],
    queryFn: () => getReceivedReviewList(sellerId),
    enabled: !!sellerId,
  });

  const { data: myReviewList } = useQuery({
    queryKey: ["myReviewList"],
    queryFn: () => getMyReviewList(),
  });

  const tabList = mine
    ? [
        {
          label: t("받은 리뷰"),
          key: "1",
          children: <ReviewList items={receivedReviewList} />,
        },
        {
          label: t("내가 쓴 리뷰"),
          key: "2",
          children: <ReviewList items={myReviewList} />,
        },
      ]
    : [
        {
          // label: t("받은 리뷰"),
          key: "1",
          children: <ReviewList items={receivedReviewList} />,
        },
      ];

  return (
    <Container>
      <BackHeader title="리뷰" onClick={() => navigate(-1)} />
      <InfoWrapper>
        <SellerInfoCard sellerId={sellerId} noButton />
      </InfoWrapper>

      <TabWithPanel item={tabList} underline={mine} />
    </Container>
  );
};

export default Review;
